import { Spinner } from 'components/index';
import { useMemo } from 'react';
import classNames from 'classnames';
import View from '../View';
import Txt from '../Txt';
import Picture from '../Picture';
import usernameToAbbr from 'helpers/usernameToAbbr';
import styles from 'components/CirclePicture/CirclePicture.module.scss';

const CirclePicture = ({
  src,
  fallbackText,
  fullText,
  reverse,
  className,
  isLoading,
}) => {
  const fullTextAbbr = useMemo(() => usernameToAbbr(fullText), [fullText]);
  const finalText = fullTextAbbr || fallbackText;

  return (
    <View
      className={classNames(
        styles.CirclePicture,
        reverse && styles.CirclePicture__reverse,
        isLoading && styles.CirclePicture__loading,
        CirclePicture.displayName,
        className
      )}
      title={fullText || fallbackText}
    >
      {src ? <Picture src={src} alt={finalText} /> : <Txt>{finalText}</Txt>}
      {isLoading ? <Spinner className={styles.Spinner} /> : null}
    </View>
  );
};

CirclePicture.displayName = 'CirclePicture';

export default CirclePicture;
